const _ = require('lodash');
const STK500 = require('stk500');
const hex = require('./intel-hex');
const sendCommand = require('stk500/lib/sendCommand.js');
const Statics = require('stk500/lib/statics.js');
const Promise = require('bluebird');
import Logger from '../../util/logger';

let createStk500 = () => {
    let stk500 = new STK500({ quiet: false });
    //stk500v1扩展
    let stk500v1 = _.extend({}, stk500, {
        bootload: function (stream, hex, opt, progressHandle, done) {
            this.progressHandle = progressHandle;
            this.length = -1;
            this.progress = -1;
            this.baseProgress = -1;
            Logger.info('stk500v1 bootload');
            console.log('stk500 is ', stk500);
            stk500.bootload.call(this, stream, hex, opt, done);
        },
        loadAddress: function (stream, useaddr, timeout, done) {
            // Logger.info('stk500v1 loadAddress');
            var progress = this.baseProgress + (Math.round(useaddr * 100 / this.length));
            if (this.progress !== progress) {
                this.progress = progress;
                var _this = this;
                console.log('progress', progress);
                this.progressHandle && setTimeout(function () {
                    _this.progressHandle(progress);
                }, 0);
            }
            stk500.loadAddress.call(this, stream, useaddr, timeout, done);
        },
        upload: function (stream, hex, pageSize, timeout, done) {
            Logger.info('stk500v1 upload');
            //this.progress = 0;
            this.baseProgress = 0;
            this.length = hex.length;
            stk500.upload.call(this, stream, hex, pageSize, timeout, done);
        },
        verify: function (stream, hex, pageSize, timeout, done) {
            Logger.info('stk500v1 verify');
            //this.progress = 50;
            this.baseProgress = 50;
            this.length = hex.length;
            stk500.verify.call(this, stream, hex, pageSize, timeout, done);
        },
        verifyPage: function (stream, writeBytes, pageSize, timeout, done) { // 覆盖第三方类库的方法，因为报错
            // Logger.info('verify page');
            let match = Buffer.concat([
                new Buffer([Statics.Resp_STK_INSYNC]),
                writeBytes,
                new Buffer([Statics.Resp_STK_OK])
            ]);

            let size = writeBytes.length >= pageSize ? pageSize : writeBytes.length;

            let opt = {
                cmd: [
                    Statics.Cmnd_STK_READ_PAGE,
                    (size >> 8) & 0xff,
                    size & 0xff,
                    0x46
                ],
                responseLength: match.length,
                timeout: timeout
            };
            sendCommand(stream, opt, function (err, data) {
                done(err, data);
            });
        }
    });
    return stk500v1;
};


let firmwarev1 = function (serialPort, data, progressHandle, callback) {
    // function ab2str(buf) {
    //     return String.fromCharCode.apply(null, new Uint8Array(buf));
    //   }
    // data = ab2str(data);
    let stk500v1 = createStk500();
    let openSerialPort, closeSerialPort;
    if (serialPort) {
        openSerialPort = Promise.promisify((cb) => {
            cb(null, serialPort);
        });
        closeSerialPort = () => {
        };
    } else {
        Logger.error('serial port not set');
    }

    let setSerialPort = Promise.promisify(serialPort.set.bind(serialPort));
    let bootload = Promise.promisify(stk500v1.bootload.bind(stk500v1));
    Logger.info('stk500 starting...');

    setTimeout(() => {
        Promise.join(
            (function () {
                return hex.parse(data).data;
            })(),
            openSerialPort()
                .then(function () {
                    return setSerialPort({
                        rts: true,
                        dtr: true
                    });
                }).delay(1)
                .then(function () {
                    return setSerialPort({
                        rts: false,
                        dtr: false
                    });
                }).delay(1)
                .then(function () {
                    return setSerialPort({
                        rts: true,
                        dtr: true
                    });
                }).delay(1),
            function (hex) {
                return hex;
            })
            .then(function (hex) {
                let options = {
                    signature: new Buffer([0x1e, 0x95, 0x0f]),
                    pageSize: 128,
                    timeout: 1000
                };
                return bootload(serialPort, hex, options, progressHandle);
            })
            .then(function () {
                return setSerialPort({
                    rts: false,
                    dtr: false
                });
            })
            .then(()=>{
                closeSerialPort();
                callback(null, true);
            })
            .catch(e=>{
                if (e) {
                    if (e.message.indexOf('3020') > -1) {
                        Logger.info('board is not match');
                        // 一般是固件协议不匹配
                    } else if (e.message.indexOf('timeout') > -1) {
                        Logger.info('board firmware: timeout');
                    }
                }
                console.log('error: ', e);
                closeSerialPort();
                callback(e, null);
            });
    }, 600);
};

export default firmwarev1;

